<template>
<div class="animated fadeIn">
  <b-card style="height:500px" class="bs-callout bs-callout-primary panelScrollBar">
    <resize-observer @notify="handleResize" />
    <div style="min-width: 1200px;">
      <b-row style="padding-bottom:35px;">
        <b-col sm="12">
          <span class="card-title wise-card-title">Input Level Result </span>
          <span class="small text-muted wise-card-subtitle"> Input Level Result</span>
        </b-col>
        <b-col sm="6">
          <br/>
          <table  id="table"
                  data-search="false"
                  data-show-columns="false"
                  data-pagination="false"
                  data-detail-view="false"
                  data-detail-formatter="detailFormatter"
                  >
              <thead>
                  <tr>
                      <th data-field="media">미디어</th>
                      <th data-field="channel">채널</th>
                      <th data-field="vehicle">비히클</th>
                      <th data-field="targetCode">타겟</th>
                      <th data-field="budgetStr">예산(만원)</th>
                      <th data-field="cpmStr">CPM</th>
                      <!-- <th data-field="eImp">E.Imp</th> -->
                      <th data-field="grps">GRPs</th>
                      <th data-field="reach1" >Reach 1+</th>
                      <th data-field="af" >A.F</th>
                  </tr>
              </thead>
          </table>
        </b-col>
        <b-col sm="6">
          <div id="inputLevelChartdiv" class="CSSAnimationChart"></div>
        </b-col>
      </b-row>
    </div>
  </b-card>
</div>
</template>
<style src="bootstrap-table/dist/bootstrap-table.min.css"></style>
<script>
import reachFormData from "../../common/ReachFormData.js";
import amchart from "../../../custom/amcharts/amcharts.js";
import serial from "../../../custom/amcharts/serial.js";
import inputLevelChart from "./inputLevelChart.js";
import bootstrapTable from "bootstrap-table";

// import Vue from 'vue'


export default {
  props: {
    rootFormData:null,
  },
  data() {
    return {
      formData: this.$_.clone(this.$session.get('inputFormData')),
      chartData: [],
      tableData: null,
      graphIndex:0
    }
  },
  created: function() {

  },
  updated: function(){
  },
  mounted: function() {
    this.getInputLevelCffcnt(this.graphIndex);
  },
  methods: {
    handleResize() {
      $('#table').bootstrapTable('resetView');
    },
    changeChart(graphIndex){
      inputLevelChart.drawChart(this.chartData[graphIndex], graphIndex+1
        , this.chartData[graphIndex][0].frequency, this.chartData[graphIndex][0].frequency>=2?true:false);
    },
    getInputLevelCffcnt(graphIndex) {

      for(var i=0; i<this.formData.mediaListResult.length; i++){
        // GRPs = (E.Imp / 타겟모수) * 100
        this.formData.mediaListResult[i].grps = ((this.formData.mediaListResult[i].eImp / this.formData.mediaListResult[i].demographic_cnt) * 100).toFixed(2);
        this.formData.mediaListResult[i].target = this.formData.mediaListResult[i].targetCode;
        // this.formData.mediaListResult[i].grps = ((this.formData.mediaListResult[i].eImp / this.formData.mediaListResult[i].target_cnt) * 100);
      }

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.formData.mediaListResult));

      var data = new FormData();
      data.append('objs', param);
      var config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };

      this.$http.post('/api/select/cffcntBetaRegression?access_token='+token, data, config)
        .then((result) => {

          for(var i=0; i <result.data.length; i++){
            // '최대GRPs' : GRPs + 200
            var resultList = this.makeResultList(result.data[i], (parseInt(result.data[i].grps) + 200));
            result.data[i].af = (result.data[i].grps / result.data[i].reach1).toFixed(2);
            if(result.data[i].frequency != '미설정'){
              this.makeFrequencyResultList(result.data[i], resultList, parseInt(result.data[i].frequency));
            }
            this.chartData.push(resultList);
          }
          inputLevelChart.drawChart(this.chartData[graphIndex], graphIndex+1
            , this.chartData[graphIndex][0].frequency, this.chartData[graphIndex][0].frequency>=2?true:false);

          for(var i=0; i<this.formData.mediaListResult.length; i++){
            this.formData.mediaListResult[i].graphId = (i+1);
            // 단순 인덱스 비교가 아니라 키값으로 비교하도록 변경 되야함 , inputlevel의 경우 uuid로 임시키를 만들어야할듯
            this.formData.mediaListResult[i].reach1 = result.data[i].reach1;
            this.formData.mediaListResult[i].af = result.data[i].af;

            var logName = this.formData.mediaListResult[i].media + this.formData.mediaListResult[i].channel + this.formData.mediaListResult[i].vehicle;
            this.$log.debug('Input Level Result ' + logName, ' eImp', this.formData.mediaListResult[i].eImp);
            this.$log.debug('Input Level Result ' + logName, ' target_cnt', this.formData.mediaListResult[i].demographic_cnt);
            this.$log.debug('Input Level Result ' + logName, ' grps', this.formData.mediaListResult[i].grps);
            this.$log.debug('Input Level Result ' + logName, ' reach1', this.formData.mediaListResult[i].reach1);
          }
          // 왜 있는거지? --> 엑셀 다운로드용?
          this.rootFormData.inputLevelResult = this.formData.mediaListResult;

          var self = this;
          $(function () {
              $('#table').bootstrapTable({
                  height : 400,
                  data: self.formData.mediaListResult,
                  onClickRow: function (row, $element) {
                    $($element).addClass('selectedActive').siblings().removeClass('selectedActive');
                    self.changeChart((row.graphId-1));
                  },
              });

              $('#table').on('click-row.bs.table', function (e, row, $element) {
                $($element).addClass('selectedActive').siblings().removeClass('selectedActive');
              });
              $("#table>tbody>tr:first").trigger('click');

              $(".mybtn-top").click(function () {
                  $('#table').bootstrapTable('scrollTo', 0);
              });

              $(".mybtn-row").click(function () {
                alert('asdasd');
                  var index = +$('.row-index').val(),
                      top = 0;
                  $('#table').find('tbody tr').each(function (i) {
                  	if (i < index) {
                      	top += $(this).height();
                      }
                  });
                  $('#table').bootstrapTable('scrollTo', top);
              });

              $(".mybtn-btm").click(function () {
                  $('#table').bootstrapTable('scrollTo', 'bottom');
              });
              var first = $("#table > tbody tr:first")
              $(first).addClass('selectedActive').siblings().removeClass('selectedActive');
          });
      })
    },
    makeResultList(resultData, max){
      var resultList = [];

      for(var i=0 ;i<max; i++){
        var reach1Result = { reach1:0, grps:0, bulletSize:1, bullet:null};
        reach1Result.reach1 = this.inputLevelCalc(resultData, i);
        reach1Result.grps = i;
        if(i == parseInt(resultData.grps)){
          reach1Result.reach1 = this.inputLevelCalc(resultData, resultData.grps);
          resultData.reach1 = reach1Result.reach1.toFixed(2); // 2018-07-16 add
          reach1Result.bulletSize=10;
          reach1Result.bullet='square';
          resultList.push(reach1Result);
        }else{
          resultList.push(reach1Result);
        }
      }
      return resultList;
    },
    makeFrequencyResultList(resultData, resultList, frequency){

      for(var i=0; i<resultList.length; i++){
        var maxReach = resultList[i].grps>=100?100:resultList[i].grps;
        var minFreCapReach = resultList[i].grps/frequency;
        minFreCapReach = minFreCapReach>=100?100:minFreCapReach;

        var reach = resultList[i].reach1;

        var minReach = resultList[i].grps/10;
        minReach = minReach>=100?100:minReach;

        var freqCapReach = ( (maxReach-minFreCapReach ) * ( (reach-minReach) / (maxReach-minReach) ) ) + minFreCapReach
        resultList[i].freqCapReach = freqCapReach;
        resultList[i].frequency = frequency; // 차트에 표시하기 위해서 임시방편
        if(i == parseInt(resultData.grps)){ // 2018-07-26 add
          // 프리퀀시캡을 사용자가 선택했으면,
          // 테이블에 사용자가 선택한 프리퀀시캡이 적용된 Reach 값을 보여줘야 하므로 이와 같은 소스추가
          var defaultReach1 = resultData.reach1;
          resultData.af = (resultData.grps / freqCapReach).toFixed(2);
          var diff = (freqCapReach.toFixed(2) - defaultReach1).toFixed(2);
          var gubun = diff>0?'+':'';
          resultData.reach1 = freqCapReach.toFixed(2) + '(' + gubun + diff + ')';  // 2018-07-26 add
        }

        if(isNaN(resultList[i].freqCapReach)){
          if(minFreCapReach == 100){
            resultList[i].freqCapReach = 100;
          }
        }
      }
    },
    inputLevelCalc(cffcnt, grps){ // 공통파일로 대체 필요
      var z = (
        cffcnt.a +
        cffcnt.b1 * Math.log(grps) +
        cffcnt.b2 * Math.pow(Math.log(grps),2) +
        cffcnt.b3 * Math.pow(Math.log(grps),3)
      );
      var z2 = 1 + Math.exp(-z);
      var result = (cffcnt.lmt/z2) * 100;
      if(isNaN(result)){ // 여기에 넣기에는 너무 부담스럽지 않을까?
        result = 0;
      }
      return result;
    }
  }
}
</script>
<style src="../../../custom/amcharts/amchart_plugins.min.css"></style>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/reach/result/InputLevelResult.vue